import { hideViewdocsError, showViewdocsError } from './getViewdocsView.js';

export function validateViewdocsForm(viewdocsForm) {
  if (!viewdocsForm.password) {
    return validateViewdocsError('login.password_error');
  }

  return validateViewdocsOk();
}

function validateViewdocsOk() {
  hideViewdocsError();
  return true;
}

function validateViewdocsError(error) {
  showViewdocsError(error);
  return false;
}
